import type {QueryClient} from "@tanstack/react-query";
import {
  LIST_STORE_SUBSCRIPTIONS_RQ_KEY,
  SEARCH_STORE_SUBSCRIPTIONS_RQ_KEY,
} from "./constants";

export function invalidateSubscriptionListQueries(queryClient: QueryClient) {
  queryClient.invalidateQueries({queryKey: [LIST_STORE_SUBSCRIPTIONS_RQ_KEY]});
  queryClient.invalidateQueries({queryKey: [SEARCH_STORE_SUBSCRIPTIONS_RQ_KEY]});
}
